<template>
	<Toast/>
	<div class="login-body">
		<div class="login-wrapper">
			<!-- <div class="login-panel">
				<img src="assets/layout/images/logo-mides.svg" class="logo" alt="QRreader-layout" style="height: 90px !important"/>

				<div class="login-form">
					<h2>Hola, accede con tu usuario y contraseña</h2>
					
					<div id="smart" class="p-grid">
						<div class="p-col-12 p-xl-12">
							<InputText id="smartuser" placeholder="Ingresa tu usuario SMART" v-model="user" style="width:200px"/>
						</div>
						<div class="p-col-12 p-xl-12">
							<Password id="smartpassword" placeholder="Contraseña" v-model="pass" toggleMask :feedback="false" style="width:200px"></Password>
						</div>
						<div class="p-col-12">
							<Button label="Ingresar" type="button" style="width:200px" @click="loginSMART()"></Button>
						</div>
					</div>
				</div>
				<p>Por más información llamar al <a href="tel:08007263">0800 72 63</a></p>
			</div> -->

			<div class="login-panel">
					<img src="assets/layout/images/logo-mides.svg" class="logo" alt="QRreader-layout" style="height: 90px !important"/>

					<!-- <div class="login-form">
						<h2>Lector QR PAT MIDES</h2>
						<p>Accede con tu usuario y contraseña</p>
						<InputText id="smartuser" placeholder="Ingresa tu usuario" v-model="user"/>
						<Password id="smartpassword" placeholder="Contraseña" v-model="pass" :feedback="false" style="width:85%"/>
						<Button label="Ingresar" type="button" @click="loginSMART()"></Button>
					</div> -->

					<div class="login-form">
						<h2>Lector QR PAT MIDES</h2>
						<p>Accede con tu usuario y contraseña ID Uruguay</p>
						<Button label="Ingresar" type="button" @click="loginIDUY()"></Button>
					</div>

					<p>Por más información llamar al <a href="tel:08007263">0800 72 63</a></p>
				</div>


			<div class="login-image">
				<div class="login-image-content">
					<h1>Lector QR</h1>
					<h1>para comedores.</h1>
					<h3>
						Aplicación para entrega<br />
						de viandas vía código alfanumérico<br />
						o QR.<br />
					</h3>
				</div>
			</div>
		</div>
	</div>
	<Dialog header="Aguarde..." v-model:visible="wait" :style="{width: '150px'}" :modal="true" :position="left">
	<div align="center">
        <ProgressSpinner style="width:50px;height:50px" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"/>
       </div>
	</Dialog>
	
</template>

<script>
import SmartService from '../service/SmartService';
import ambiente from "../../public/js/ambientes";
export default {
	name: "Login",
	data(){
		return{
            wait: false,
            urlTuID: ambiente.tuIDLOGIN,
            urlRegistro: ambiente.tuIDRegistroURL,
			user: "",
			pass: "",
		}
	},
	smartService: null,
    created() {
         this.smartService = new SmartService();
    },	
	methods: {
			loginIDUY(){
				this.wait= true;
				localStorage.clear();
				this.smartService.setAmbiente();
				window.location = localStorage.urlIDUruguay+"/authorize?"+
				"client_id="+localStorage.client_id+
				"&redirect_uri="+encodeURIComponent(localStorage.urlLogin)+
				"&scope=openid%20personal_info%20document%20email%20auth_info"+
				"&response_type=code"+
				"&response_mode=query";
				/* this.smartService.autenticar("37317064", "00000S2W9", "0").then(token => {        	
					localStorage.token = token;
					//CAMBIAR ajuste para probar nivel cuando no se levanta usuario gub.uy
					localStorage.level = 2;
					this.$router.replace({ name: "Datos personales" });
					this.wait=false;
				})  */
			},


			loginSMART(){
				this.wait= true;
				localStorage.clear();
				this.smartService.setAmbiente();
				if (this.user != "" && this.pass != "") {
					this.smartService.autenticarSMART(139, this.user, this.pass).then(data => {        	
						if(data!=null) {
							localStorage.token = data.Token;
							localStorage.cedula = data.Documento;
							localStorage.nombre = data.Nombre;
							localStorage.tec_id = data.Id;
							localStorage.multiplicador = 1;
							this.$router.replace({ name: "Punto móvil" });
						} else {
							this.$toast.add({severity:'error', summary: 'Error en la autenticación', detail: 'Usuario y/o contraseña incorrecta', life: 3000});
						}
						this.wait=false;
					})
					.catch((e) => {
						console.log(e);
						this.wait=false;            	
						this.$toast.add({severity:'error', summary: 'Error en la autenticación', detail: 'Ha ocurrido un error al comunicarse con el servidor', life: 3000});
						});
				} 				
				else {
					this.$toast.add({severity:'error', summary: 'Error en la autenticación', detail: 'Debe ingresar usuario y contraseña', life: 3000});
					this.wait=false;
				}
			}
	},
}; 
</script>
